/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetApplicationsByProjectPathParams = NonNullable<
  operations['internalGetApplicationsByProject']['parameters']['path']
>;

export type InternalGetApplicationsByProjectQueryParams = NonNullable<
  operations['internalGetApplicationsByProject']['parameters']['query']
>;

export interface Input extends InternalGetApplicationsByProjectPathParams {
  apiVersion?: string;
  query?: InternalGetApplicationsByProjectQueryParams;
}

export async function internalGetApplicationsByProject(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/applications', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
